import { constantsData } from "../data/constants";

async function postJson(route, data, session_id, add_server_url = true) {
  let options = {
    method: "post",
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
       Authorization: `${
        session_id !== "" ? "Bearer " + session_id : session_id
      }`,
    },
  };

  let response = await fetch(`${route}`, options);

  let json_body = await response.json();

  if (json_body.statusCode !== constantsData.successCode) {
    if (json_body.statusCode === constantsData.invalid_session) {
      throw new Error(json_body.statusMsg);
    } else {
      throw new Error(json_body.statusMsg);
    }
  }

  return json_body;
}

async function getJson(route, session_id = "", add_server_url = true) {
  let options = {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `${
        session_id !== "" ? "Bearer " + session_id : session_id
      }`,    },
  };

  const response = await fetch(route, options);

  let json_body = await response.json();
  if (json_body.statusCode !== constantsData.successCode) {
    if (json_body.statusCode === constantsData.invalid_session) {
      throw new Error(json_body.statusMsg);
    } else {
      throw new Error(json_body.statusMsg);
    }
  }

  return json_body;
}

async function putJson(route, data, session_id, add_server_url = true) {
  let options = {
    method: "put",
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `${
        session_id !== "" ? "Bearer " + session_id : session_id
      }`,    },
  };

  let response = await fetch(`${route}`, options);

  let json_body = await response.json();

  if (json_body.statusCode !== constantsData.successCode) {
    if (json_body.statusCode === constantsData.invalid_session) {
      throw new Error(json_body.statusMsg);
    } else {
      throw new Error(json_body.statusMsg);
    }
  }

  return json_body;
}



async function authJson(route, data, session_id, add_server_url = true) {
  let options = {
    method: "post",
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
  };

  let response = await fetch(`${route}`, options);

  let json_body = await response.json();

  if (json_body.statusCode !== constantsData.successCode) {
    if (json_body.statusCode === constantsData.invalid_session) {
      throw new Error(json_body.statusMsg);
    } else {
      throw new Error(json_body.statusMsg);
    }
  }

  return json_body;
}


export { getJson, postJson, putJson ,authJson};
